import*as React from"react";import{mediaCSS,ZERO_BREAKPOINT}from"@redocly/reference-docs";import styled from"../../../styled-components";import{Menu}from"../../Menu/Menu";import{NavButtonsWrapper}from"../../styled/";import{Box,Button,Flex}from"@redocly/ui";import{NextPageWrapperWithRightPanel}from"../../../components/styled";export default function SidebarLayout(a){const{items:b,location:c,prevPage:d,nextPage:e,withRightPanel:f,withToc:g,children:h,context:i,apiVersionId:j,apiVersions:k,pageId:l}=a,m=f?NextPageWrapperWithRightPanel:NextPageWrapper;return React.createElement(FlexWrapper,{position:"relative",flex:"1 0 auto"},React.createElement(Menu,{items:b,location:c,context:i||{},apiVersionId:j,apiVersions:k,pageId:l}),React.createElement(Box,{width:{xs:"100%",medium:0},flex:"1 1 auto"},h,(e||d)&&React.createElement(PageWrapper,null,React.createElement(m,{withToc:g,className:"next-to-wrap"},d&&React.createElement(LinkBack,{to:d.link,small:!0,transparent:!0,"data-cy":"back-to"},"Back to ",React.createElement("strong",null,d.label)),e&&React.createElement(LinkForward,{to:e.link,small:!0,transparent:!0,"data-cy":"next-to"},"Next to ",React.createElement("strong",null,e.label))),g&&React.createElement(TableOfContentStub,null))))}const FlexWrapper=styled(Flex)`
  ${({theme:a})=>mediaCSS({flexDirection:{[ZERO_BREAKPOINT]:"column",[a.sidebar.showAtBreakpoint]:"row"}})}
`;export const PageWrapper=styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`;const NextPageWrapper=styled(NavButtonsWrapper)`
  padding-left: 0;
  padding-right: 0;

  @media only screen and (min-width: ${({theme:a})=>a.breakpoints.medium}) {
    margin-top: 0;
    margin-bottom: 0;
  }
`,TableOfContentStub=styled.div`
  display: none !important;
  @media only screen and (min-width: ${({theme:a})=>a.breakpoints.medium}) {
    width: ${({theme:a})=>a.tocPanel.width};
    display: block !important;
  }
`,PaginationLink=styled(Button)`
  margin-bottom: 0.5em;

  & + & {
    margin-left: auto;
  }

  @media only screen and (max-width: ${({theme:a})=>a.breakpoints.small}) {
    margin-left: auto;
  }
`,LinkBack=styled(PaginationLink)`
  &:only-child {
    margin-left: 0;
    margin-right: auto;
  }
`,LinkForward=styled(PaginationLink)`
  margin-left: auto;
`;